import React, { useRef } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react';
import theme from '../../../theme.js';

const GearAlertDialog = ({
  isOpen,
  onClose,
  title,
  message,
  isEquipment,
  onConfirm,
}) => {
  const cancelRef = useRef();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>
          <AlertDialogBody>{message}</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              No
            </Button>
            <Button
              backgroundColor={
                isEquipment
                  ? theme.colors.leftSideMain
                  : theme.colors.rightSideMain
              }
              color={theme.colors.neutralLight}
              _hover={{
                backgroundColor: isEquipment
                  ? theme.colors.leftSideDark
                  : theme.colors.rightSideDark,
              }}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              ml={3}
            >
              Yes
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default GearAlertDialog;
